import { Box } from "@mui/material";
import React from "react";
import MaterialTypography from "../../../components/MaterialTypography";
import DropArea from "../../../components/drag/GragCard/DropArea";
import DragCard from "../../../components/drag/GragCard";

const StatusColumn = ({ data = [], onDrop, status, setActiveCard, title }) => {
  const filteredData = data?.filter((v) => v?.status === status);
  return (
    <div className="drag_mainbox">
      <h2 className="dragbox_title"> {title}</h2>
      <DropArea onDrop={() => onDrop(status, 0)} />
      {data?.map(
        (v, i) =>
          v?.status == status && (
            <React.Fragment key={i}>
              <DragCard
                id={v?.id}
                moduleName={v?.moduleName}
                taskName={v?.taskName}
                startDate={v?.startDate}
                endDate={v?.endDate}
                hours={v?.hours}
                setActiveCard={setActiveCard}
                index={i}
                priority={v?.priority}
              />
              <DropArea onDrop={() => onDrop(status, 0)} />
            </React.Fragment>
          )
      )}
    </div>
  );
};

export default StatusColumn;
